import {Box, Badge, Stack, Typography } from "@mui/material";
// import { tokens } from "../theme";
import { styled } from "@mui/material/styles";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LanIcon from '@mui/icons-material/Lan';
import PhoneIcon from '@mui/icons-material/Phone';
import HelpIcon from '@mui/icons-material/Help';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import truncateString from "../utils/trancate";

const AppealAvatar = ({ provider, group, appeal, type="element", truncatePerformance=30, truncateSubtitle=80 }) => {
    // const theme = useTheme();
    // const colors = tokens(theme.palette.mode);

    const providerPerformance = provider ? provider.name : ""

    const groupPerformance = () => {
        if (appeal.source_type == 'dialog') {
            return "Dialog"
        }
        else {
            return group ? group.name : "Unknown"
        }
    }

    const name = () => {
        switch(appeal.source_type) {
            case 'user':
                return appeal.crm_object.login ? appeal.crm_object.login : appeal.source
            case 'host': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            case 'network': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            case 'system_user': 
                return appeal.crm_object.performance ? appeal.crm_object.performance : appeal.source
            case 'dialog': 
                return appeal.who_create ? appeal.who_create : appeal.source
            default: 
                return appeal.source
        }
    }

    const renderContent = () => {
        switch(appeal.source_type) {
            case 'user':
                return <AccountCircleIcon fontSize='large' color="action" />
            case 'host': 
                return <LanIcon fontSize='large' color="action" />
            case 'incoming_call': 
                return <PhoneIcon fontSize='large' color="action" />
            case 'network':
                return <LanIcon fontSize='large' color="action" />
            case 'system_user':
                return <ManageAccountsIcon fontSize='large' color="action" />
            default: 
                return <HelpIcon fontSize='large' color="action" />
        }
    }

    return (
        <Stack
            // onClick={() => {
            //     dispatch(ToggleSidebar());
            // }}
            spacing={1}
            direction="row"
        >
            <Box alignContent="center" >
                {appeal.is_open 
                    ? 
                        <StyledBadge
                            overlap="circular"
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            variant="dot"
                        >
                            {renderContent()}
                        </StyledBadge>
                    :   renderContent()
                }
            </Box>
            {type == "header" &&
                <Stack spacing={0.1}>
                    <Typography variant="subtitle2">{truncateString(providerPerformance + " - " + groupPerformance(), truncateSubtitle)}</Typography>
                    <Typography variant="caption">{truncateString(name(), truncateSubtitle)}</Typography>   
                </Stack>
            }
            {type == "element" &&
                <Stack spacing={0.1}>
                    <Typography variant="subtitle2">{truncateString(name(), truncatePerformance)}</Typography>
                    <Typography variant="caption">{truncateString(appeal.last_comment, truncateSubtitle)}</Typography> 
                </Stack>
            }
        </Stack>
    );
};

const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
        backgroundColor: "#44b700",
        color: "#44b700",
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        "&::after": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            animation: "ripple 1.2s infinite ease-in-out",
            border: "1px solid currentColor",
            content: '""',
        },
    },
    "@keyframes ripple": {
        "0%": {
            transform: "scale(.8)",
            opacity: 1,
        },
        "100%": {
            transform: "scale(2.4)",
            opacity: 0,
        },
    },
}));

export default AppealAvatar;